import React from 'react';
import { styled } from '@mui/system';
import Drawer from '@mui/material/Drawer';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Button from '@mui/material/Button';
import AddIcon from '@mui/icons-material/Add';
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import VideoLibraryIcon from '@mui/icons-material/VideoLibrary';
import ImageIcon from '@mui/icons-material/Image';
import UploadFileIcon from '@mui/icons-material/UploadFile';


const drawerWidth = 270;

const DrawerStyled = styled(Drawer)({
  width: drawerWidth,
  flexShrink: 0,
  '& .MuiDrawer-paper': {
    width: drawerWidth,
    border: 'none !important',
  },
});

const DrawerPaperStyled = styled('div')({
  width: drawerWidth,
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
});

const ToolbarStyled = styled('div')(({ theme }) => ({
  ...theme.mixins.toolbar,
  justifyContent: 'center',
}));

const Logo = styled('div')(({ theme }) => ({
  fontSize: '32px',
  fontWeight: 'bold',
  fontFamily: theme.typography.fontFamily,
  paddingTop: theme.spacing(4),
  paddingBottom: theme.spacing(3),
  padding: theme.spacing(3),
  color: theme.palette.primary.main,
}));

const ButtonWrapper = styled('div')(({ theme }) => ({
  margin: theme.spacing(2),
  marginBottom: theme.spacing(5),
  marginTop: 'auto',
  display: 'flex',
  justifyContent: 'center',
}));

const ListItemStyled = styled(ListItem)({
  display: 'flex',
  paddingLeft: '24px !important',
});

const ListItemTextStyled = styled(ListItemText)({
  font: 'inherit',
  color: '#969EA9 !important',
  fontSize: '18px !important',
  alignItems: 'left',
  textAlign: 'left',
});

const ListItemIconStyled = styled(ListItemIcon)({
  minWidth: '40px !important',
  color: '#969EA9 !important',
});

const ListItemIconIconStyled = styled(FormatListBulletedIcon)({
  fontSize: '1.65rem !important',
});

const VideoIconStyled = styled(VideoLibraryIcon)({
  fontSize: '1.65rem !important',
});

const ImageIconStyled = styled(ImageIcon)({
  fontSize: '1.65rem !important',
});

const Sidebar = ({ navigate }) => {
  return (
    <DrawerStyled
      variant="permanent"
      sx={{
        '& .MuiDrawer-paper': {
          width: drawerWidth,
        },
      }}
    >
      <DrawerPaperStyled>
        <ToolbarStyled>
          <Logo>3D Admin</Logo>
        </ToolbarStyled>
        <List>
          <ListItemStyled button key="Renders">
            <ListItemIconStyled>
              <ListItemIconIconStyled />
            </ListItemIconStyled>
            <ListItemTextStyled primary="Renders" align="left" onClick={() => { navigate('/list') }} />
          </ListItemStyled>
          <ListItemStyled button key="Projections">
            <ListItemIconStyled>
              <ListItemIconIconStyled />
            </ListItemIconStyled>
            <ListItemTextStyled primary="Projections" align="left" onClick={() => { navigate('/projections/') }} />
          </ListItemStyled>
          <ListItemStyled button key="Search Tool">
            <ListItemIconStyled>
              <ListItemIconIconStyled />
            </ListItemIconStyled>
            <ListItemTextStyled primary="Search Tool" align="left" onClick={() => { navigate('/search/') }} />
          </ListItemStyled>
          <ListItemStyled button key="POM">
            <ListItemIconStyled>
              <ListItemIconIconStyled />
            </ListItemIconStyled>
            <ListItemTextStyled primary="POM" align="left" onClick={() => { navigate('/pom/') }} />
          </ListItemStyled>
          <ListItemStyled button key="POM scenes tool">
            <ListItemIconStyled>
              <ListItemIconIconStyled />
            </ListItemIconStyled>
            <ListItemTextStyled primary="POM scenes tool" align="left" onClick={() => { navigate('/pom-scenes/') }} />
          </ListItemStyled>
          <ListItemStyled button key="Video Upload">
            <ListItemIconStyled>
              <VideoIconStyled />
            </ListItemIconStyled>
            <ListItemTextStyled primary="Video Upload" align="left" onClick={() => { navigate('/video-upload/') }} />
          </ListItemStyled>
          <ListItemStyled button key="TGA Images">
            <ListItemIconStyled>
              <ImageIconStyled />
            </ListItemIconStyled>
            <ListItemTextStyled primary="TGA Images" align="left" onClick={() => { navigate('/tga-upload/') }} />
          </ListItemStyled>
          <ListItemStyled
            button
            key="Batch Approve"
            onClick={() => navigate('/products/approve-csv')}
          >
            <ListItemIconStyled>
              <UploadFileIcon />
            </ListItemIconStyled>
            <ListItemTextStyled
              primary="Batch Approve"
              align="left"
            />
          </ListItemStyled>
        </List>
        <ButtonWrapper>
          <Button
            onClick={() => { navigate('/new') }}
            variant="contained"
            color="primary"
            startIcon={<AddIcon />}
          >
            New render
          </Button>
        </ButtonWrapper>
      </DrawerPaperStyled>
    </DrawerStyled>
  );
};

export default Sidebar;